/* eslint-disable max-len */
import React from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { getNumberOfEmployeesLabel } from '../../../../utils/AppUtil';
import { DEFAULT_EMPTY_CONTENT } from '../../../../shared/Constants';

const i18n = defineMessages({
  manual: {
    id: 'dashboard.respondents.deletionRule.manual',
    defaultMessage: 'Delete manually',
  },
  afterDays: {
    id: 'dashboard.respondents.deletionRule.afterDays',
    defaultMessage: '{numberOfDaysToAnonymizeAfter} days after completion',
  },
  unlimitedIncludedInPlan: {
    id: 'dashboard.respondents.included-in-plan.unlimited',
    defaultMessage: 'Unlimited',
  },
});

const RespondentTypeData = ({ respondentData }) => {
  const {
    includedInPlan,
    presentlyUsed,
    deletionRule: { type, numberOfDaysToAnonymizeAfter },
  } = respondentData;

  const { formatMessage } = useIntl();

  const getRespondentsIncludedInPlan = () => {
    const INCLUDED_IN_PLAN_UNLIMITED = 'UNLIMITED';

    if (!includedInPlan) {
      return DEFAULT_EMPTY_CONTENT;
    }

    if (includedInPlan === INCLUDED_IN_PLAN_UNLIMITED) {
      return formatMessage(i18n.unlimitedIncludedInPlan);
    }

    return getNumberOfEmployeesLabel(includedInPlan);
  };

  const respondentsIncludedInPlan = getRespondentsIncludedInPlan();
  const deletionRule =
    type === 'MANUAL' ? formatMessage(i18n.manual) : formatMessage(i18n.afterDays, { numberOfDaysToAnonymizeAfter });

  return (
    <>
      <div className="data">
        <FormattedMessage id="dashboard.respondents.included-in-plan" defaultMessage="Included in plan:" />
        <span>{respondentsIncludedInPlan}</span>
      </div>
      <div className="data">
        <FormattedMessage id="dashboard.respondents.presently-used" defaultMessage="Presently used:" />
        <span>{presentlyUsed}</span>
      </div>
      <div className="data">
        <FormattedMessage id="dashboard.respondents.deletion-rule" defaultMessage="Deletion rule:" />
        <span>{deletionRule}</span>
      </div>
    </>
  );
};

RespondentTypeData.propTypes = {
  respondentData: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default RespondentTypeData;
